import type { SharedBillingPageProps } from "../billing/SharedBillingPage";
import type { SetupAdapter, SetupStep } from "./onboardingTypes";
/** Uses the persisted subscription, not local Next/Done flags. */
export function createBillingSetupAdapter(billing: SharedBillingPageProps, options: {
  canManageContract: boolean;
  loadSteps?: () => Promise<SetupStep[]>;
  contractRequired?: boolean;
}): SetupAdapter {
  return {
    billing,
    load: async () => {
      const [snapshot, steps] = await Promise.all([billing.adapter.load(), options.loadSteps?.() ?? Promise.resolve([])]);
      const subscription = snapshot.subscription;
      // A lapsed contract has to be renewed; the app stays readable and the backend refuses operations.
      const contractLapsed = !!subscription?.planId.trim() && subscription.accessState === "expired";
      const contractComplete = !!subscription?.planId.trim() && !contractLapsed;
      const contractEndsAt = subscription?.accessState === "ending" || subscription?.accessState === "payment_retry"
        ? subscription.paidThrough : undefined;
      return { steps, contractComplete, contractLapsed, contractEndsAt, canManageContract: options.canManageContract,
        contractRequired: !contractComplete && options.contractRequired !== false };
    },
  };
}
